import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material/styles';

interface ThemeProps {
  children: React.ReactNode;
}

// Extend the PaletteOptions type
declare module '@mui/material/styles' {
  interface PaletteOptions {
    carrot: {
      main: string;
      dark?: string;
      light?: string;
      contrastText?: string;
    };
  }
}

// MUI defaults and available properties
// https://mui.com/material-ui/customization/default-theme
let theme = createTheme({
  palette: {
    primary: {
      main: '#182955',
    },
    secondary: {
      main: '#e9ecef',
    },
    success: {
      main: '#8fdc8f',
    },
    warning: {
      main: '#e4ea6b',
    },
    error: {
      main: '#ea846b',
    },
    carrot: {
      main: '#FB9702',
    },
  },
  spacing: 4,
  typography: {
    h1: {
      fontSize: '3rem',
    },
    h3: {
      fontSize: '1.5rem',
    },
    h5: {
      fontSize: '1rem',
    },
    h6: {
      fontSize: '0.75rem',
    },
  },
});

theme = responsiveFontSizes(theme);

const MUIThemeProvider: React.FC<ThemeProps> = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default MUIThemeProvider;
